import React from 'react';

import { cn } from 'src/utils/shadcn';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn('animate-pulse rounded-md bg-gray-200 dark:bg-gray-800', className)}
            role="status"
            {...props}
        />
    );
}

function VideoSkeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            role="status"
            className={cn(
                'flex animate-pulse items-center justify-center rounded-lg bg-gray-200 dark:bg-gray-800',
                className,
            )}
            {...props}
        >
            <svg
                className="size-10 text-gray-50 dark:text-gray-600"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 16 20"
            >
                <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM9 13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2Zm4 .382a1 1 0 0 1-1.447.894L10 13v-2l1.553-1.276a1 1 0 0 1 1.447.894v2.764Z" />
            </svg>
            <span className="sr-only">Loading...</span>
        </div>
    );
}

export { Skeleton, VideoSkeleton };
